(ns common.schema.entities.decision-aifm-exit
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.entities.decision :as decision]
   [common.schema.entities.common.options :as common-options]))

(def schema
  (concat
   decision/schema
   (su/single-ref-field :decision/deciding-legal-entity
                        "Deciding legal entity"
                        [:entity.type/company]
                        {:authorization su/access-user-user
                         :default-field-visibility :in-use})

   (su/single-ref-field :decision/portfolio-manager
                        "Portfolio manager"
                        [:entity.type/account :entity.type/person]
                        {:authorization su/access-user-user
                         :default-field-visibility :in-use})

   (su/text-multiline-field :decision/portfolio-manager-notes
                            "Portfolio manager - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/keyword-field :decision/pre-exit-checks-completed
                     "Pre-exit checks completed"
                     common-options/condition-true-false-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/pre-exit-checks-completed-notes
                            "Pre-exit checks completed - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/keyword-field :decision/ic-recommended-the-exit
                     "Investment committee has recommended the exit"
                     common-options/condition-true-false-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/ic-recommended-the-exit-notes
                            "Investment committee has recommended the exit - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   ;;TODO something exit specific?
   #_#_(su/keyword-field :decision/fund-has-sufficient-capacity
                     "Fund has sufficient capacity to complete the deal"
                     common-options/condition-true-false-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/fund-has-sufficient-capacity-notes
                            "Fund has sufficient capacity to complete the deal - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})


   (su/keyword-field :decision/complies-with-investment-strategy
                     "Proposed investment complies with investment strategy, criteria and restrictions"
                     common-options/condition-true-false-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/complies-with-investment-strategy-notes
                            "Proposed investment complies with investment strategy, criteria and restrictions - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/keyword-field :decision/portfolio-manager-approves-proposed-exit
                     "Portfolio manager approves the proposed exit"
                     common-options/condition-true-false-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/portfolio-manager-approves-proposed-exit-notes
                            "Portfolio manager approves the proposed exit - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/multi-ref-field :decision/conditions
                       "Conditions"
                       [:entity.type/decision-condition]
                       {:authorization su/access-user-user
                        :default-field-visibility :in-use})

   (su/keyword-field :decision/advisory-board-approval-needed
                     "Advisory board approval needed?"
                     common-options/needed-not-needed-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/advisory-board-approval-needed-notes
                            "Advisory board approval needed - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})))

(def required-fields
  #{:decision/date
    :decision/deciding-party
    :decision/portfolio-manager
    :decision/portfolio-manager-approves-proposed-exit
    :decision/pre-exit-checks-completed
    :decision/ic-recommended-the-exit
    ;;:decision/fund-has-sufficient-capacity
    ;;:decision/board-approval-needed
    :decision/advisory-board-approval-needed})
